import React, {Component} from 'react';
import SmartDialog from "../SmartDialog/SmartDialog";
import {UserDepartments} from "../../common/Constants";
import {Button} from 'reactstrap';
import CheckInput from "../CheckInput/CheckInput";
import TTLProxy from "../../common/TTLAsyncProxy";
import {AdminEndpoints} from "../../common/ProxyEndpoints";
import HTML from '../../common/HtmlHelpers';
import Utils from "../../common/Utils";
import MDProgress from 'react-md-progress-bar';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Styles = {

    checkOptionStyle: {
        padding: '10px',
        borderRadius: '2px' ,
        marginBottom: '4px'
    }

};

const Departments =  [
    {
        text: "Finance Department",
        description: "Manage money & other financial aspect of the business. This department is ideally assigned to accountants and other financial personnel.",
        value: UserDepartments.Finance
    },
    {
        text: "Operations Department",
        description: "Provide operation support for tractor deployment and assignment. They are also responsible for consolidating tractor requests and matching suitable tractors.",
        value: UserDepartments.Operations
    },
    {
        text: "Human Resource (HR) Department",
        description: "Responsible managing human resources to improve efficiency and delivery of services. They also monitor and evaluate the performance of other workers",
        value: UserDepartments.HumanResource
    },
    {
        text: "Information Technology (IT) Department",
        description: "Provide technical assistance and development of software services for efficient running of the business. Ideally assigned to software developers and other related personnel",
        value: UserDepartments.IT
    }
];

class ManageDepartmentDialog extends Component{

    static propTypes = {
        onUpdate: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = this.getInitialState();
        this.proxy = TTLProxy.getInstance();
    }

    getInitialState(departments = [],user = null){

        return {
            departments: departments,
            user: user,
            isBusy: false
        };

    }

    show(user){

        this.setState(this.getInitialState( _.clone(user.departments) ,user));

        this._dlg.show();
    }

    onSaveChanges(){

        const props = this.props;
        const state = this.state;
        const user = state.user;

        this.setState({
            isBusy: true
        });

        return this.proxy.processRequest( AdminEndpoints.setDepartments(user.id,state.departments) ).then(response => {

            if(response.ok && props.onUpdate){
                props.onUpdate(user);
            }

            //
            this.setState({ isBusy: false });

            // hide dialog
            this._dlg.toggle();

        }).catch(err => {

            HTML.toastWarning(Utils.getResponseError(err));

            this.setState({
                isBusy: false
            });

        });

    }

    render(){

        const state = this.state;
        const departments = state.departments;

        return <SmartDialog ref={r => this._dlg = r} title={"Manage User Departments"} showCancelButton={false}>

            {Departments.map((item,key) => {

               return <CheckInput  key={key}
                                   title={item.text}
                                   style={Styles.checkOptionStyle}
                                   checked={departments.indexOf(item.value) >= 0}
                                   hint={item.description}
                                   onChange={(evt) => {

                                        const value = evt.target.checked;
                                        const departments = this.state.departments;

                                        if(value) {

                                            if (departments.indexOf(item.value) < 0)
                                                departments.push(item.value);

                                        }
                                        else {

                                            const index = departments.findIndex(x => x == item.value);
                                            if(index >= 0)
                                                departments.splice(index,1);

                                        }

                                        this.setState({
                                            departments: departments
                                        });

                                    }} />

            })}

            {this.state.isBusy && <MDProgress overlay={true}/>}

            <hr/>

            <div className="clearfix">

                <div className="pull-right">
                    <Button color={"primary"} onClick={this.onSaveChanges.bind(this)} outline={true} style={{borderRadius: 4}}><i className="fa fa-edit"></i> Save Changes</Button>
                </div>

            </div>

            </SmartDialog>
    }
}

export default ManageDepartmentDialog;


// WEBPACK FOOTER //
// ./src/components/ManageDepartmentDialog/ManageDepartmentDialog.js